import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { Psp } from '../api/dto/psp';
import { PspMetadados } from '../api/dto/psp-metadados';

@Injectable({
  providedIn: 'root'
})
export class PspService {

  private url : string = UrlServidor.URL_BASE + 'psps';

  constructor(private http: HttpClient) { }

  buscarPorId(pspId?: number): Observable<Psp> {
    return this.http.get<Psp>(`${this.url}/${pspId}`);
  }

  buscarMetadados(pspId?: number): Observable<PspMetadados[]> {
    return this.http.get<PspMetadados[]>(`${this.url}/${pspId}/metadados`);
  }

  listar(): Observable<Psp[]> {
    return this.http.get<Psp[]>(this.url);
  }

}
